// test2578
(2578 && 0);
